import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type InvalidatePatientElectronicPrescriptionParams =
	InsuredPatientCommandParams & {
		prescriptionCode: string;
	};

export const InvalidatePatientElectronicPrescription = (
	params: InvalidatePatientElectronicPrescriptionParams,
): Command => {
	return {
		operation: 'ZneplatniPreskripcnyZaznam_v6',
		params,
	};
};
